// extracted by mini-css-extract-plugin
export default {"tooltip__separator":"ElementTooltipSeparator_tooltip__separator__16UnD"};